import { render, staticRenderFns } from "./CarFrontFlat.vue?vue&type=template&id=365d564e"
import script from "./CarFrontFlat.vue?vue&type=script&lang=js"
export * from "./CarFrontFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports